<template>
  <SectionShell :icon="meta.icon || 'calendar'" :label="meta.label || fieldKey" :count="r ? 1 : 0">
    <div :style="{ display: 'flex', alignItems: 'center', gap: '7px', padding: '2px 2px 0' }">
      <DateField :value="lo" placeholder="From" @change="commit($event, hi)" />
      <span :style="{ fontSize: '11px', color: 'var(--p-surface-400)', fontFamily: mono }">TO</span>
      <DateField :value="hi" placeholder="To" @change="commit(lo, $event)" />
      <button
        v-if="r"
        title="Clear range"
        :style="{ background: 'transparent', border: 0, padding: '2px', cursor: 'pointer', color: 'var(--p-surface-400)', display: 'flex' }"
        @click="search.clearField(fieldKey)"
      >
        <i class="pi pi-times" :style="{ fontSize: '11px' }" />
      </button>
    </div>
    <div :style="{ padding: '6px 4px 0', fontSize: '10.5px', color: 'var(--p-surface-400)', fontFamily: mono }">
      {{ r ? `${fieldKey}:[${r.lower || '*'} TO ${r.upper || '*'}]` : 'open · pick a start or end' }}
    </div>
  </SectionShell>
</template>

<script setup>
// Date range section (From TO To via calendar fields). Ported from
// fql-search.jsx DateRangeSection.
import { computed } from 'vue'
import { mono } from './bits.js'
import SectionShell from './SectionShell.vue'
import DateField from './DateField.vue'

// SearchSidebar hands every section the same prop bag. This one reads no decl,
// and `inheritAttrs: false` keeps the undeclared binding off SectionShell's
// root element rather than letting it render there as an attribute.
defineOptions({ name: 'DateRangeSection', inheritAttrs: false })

const props = defineProps({
  fieldKey: { type: String, required: true },
  fieldSlot: { type: Object, required: true },
  meta: { type: Object, default: () => ({}) },
  search: { type: Object, required: true },
})

const r = computed(() => props.fieldSlot.range)
const lo = computed(() => (r.value && r.value.lower ? r.value.lower : ''))
const hi = computed(() => (r.value && r.value.upper ? r.value.upper : ''))
function commit(nl, nh) {
  if (!nl && !nh) {
    props.search.clearField(props.fieldKey)
    return
  }
  props.search.setRange(props.fieldKey, { lower: nl || null, upper: nh || null, includeLower: true, includeUpper: true })
}
</script>
